import React, {Component} from 'react';

import Workflow from "../core/Workflow";
import axios from "axios";
import AuthService from "../../AuthService";
import Moment from "moment";


class Utilisateur extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();
        this.state = {
            workflowInitData : {
                WORKFLOW_ID: 12,
                PARAM_rootId: this.props.match.params.rootId,
                PARAM_utilisateurId: 1, // TODO récupérer l'ID du localStorage stocké à partir du token
                villeList: [],
                assoUtilisateurVilleList: []
            },
            rootId: this.props.match.params.rootId,
        }
        this.loadData(this.state.rootId);
        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    async loadData(utilisateurId) {
        await axios.post(AuthService.getUrl('/getVillesByUtilisateur'), {utilisateurId: this.state.rootId}, AuthService.getAuthHeader()).then(res => {
            this.setState({
                villeList: res.data.data['villeList'],
                assoUtilisateurVilleList: res.data.data['assoUtilisateurVilleList']
            });
        });
    }

    async checkVille(e) {
        let value = e.target.value;
        await axios.post(AuthService.getUrl('/setVilleByUtilisateur'), {utilisateurId: this.state.rootId, villeId: value}, AuthService.getAuthHeader()).then(res => {
        });
        await this.loadData(this.state.rootId);
    }

    isAssociated(villeId) {
        for (const asso of this.state.assoUtilisateurVilleList) {
            if (asso.ville.id === villeId) return true;
        }
        return false;
    }

    coreChange(e) {
    }

    async coreExternalCall(method) {
    	if (method === "delete") {
        	await axios.post(AuthService.getUrl('/deleteUtilisateur'), {id: this.state.rootId}, AuthService.getAuthHeader()).then(
                res => {
                    this.props.history.push('/admin/utilisateurs');
                }
            );
        }
        if (method === "leave") {
            this.props.history.push('/admin/utilisateurs');
        }
    }

    coreSubmit(data) {
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                    <div className="errorMessage">
                        <span>{this.state.errorMessage}</span>
                    </div>
                }
                {!!(this.state.validMessage) &&
                    <div className="actionMessage">
                        <span>{this.state.validMessage}</span>
                    </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.rootId}/>
                {<div name="villes">
                    {this.state.villeList?.map(ville => (
                        <div>
                            <input type="checkbox" id={ville.id} value={ville.id} checked={this.isAssociated(ville.id)} onChange={e => this.checkVille(e)}/>
                            <label htmlFor="scales">{ville.nom}</label>
                        </div>
                    ))}
                </div>}
            </div>
        );
    }
}

export default Utilisateur;
